export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_12W_30_00',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_4w_29_99_12w_30_usd',
			EUR: 'simple_premium_comm_4w_29_99_12w_30_eur',
			GBP: 'simple_premium_comm_4w_29_99_12w_30_gbp',
			CAD: 'simple_premium_comm_4w_49_99_12w_50_cad',
			AUD: 'simple_premium_comm_4w_49_99_12w_50_aud',
			DKK: 'simple_premium_comm_4w_259_12w_259_dkk',
			SEK: 'simple_premium_comm_4w_399_12w_399_sek',
			NOK: 'simple_premium_comm_4w_399_12w_399_nok',
			BRL: 'simple_premium_comm_4w_199_90_12w_199_90_brl',
			MXN: 'simple_premium_comm_4w_499_12w_499_mxn',
			TRY: 'simple_premium_comm_4w_999_12w_1000_try',
			ARS: 'simple_premium_comm_4w_39990_12w_40000_ars',
			COP: 'simple_premium_comm_4w_119990_12w_123000_cop',
			CLP: 'simple_premium_comm_4w_29990_12w_30000_clp',
		},
		primer: 'prd_1I77DlXYqa3Q',
	},
	model: {
		commitment_period: 3,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 30,
			EUR: 30,
			GBP: 30,
			CAD: 50,
			AUD: 50,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 1000,
			ARS: 40000,
			COP: 123000,
			CLP: 30000,
		},
		originalPriceMap: {
			USD: 30,
			EUR: 30,
			GBP: 30,
			CAD: 50,
			AUD: 50,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 1000,
			ARS: 40000,
			COP: 123000,
			CLP: 30000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
